import { handleAuthentication } from "@/services/auth";
export default {
  name: "",
  created: function created() {
    this.$nextTick(function () {
      handleAuthentication();
    });
  }
};